import * as React from "react";

import cn from "classnames";

import styles from "./ProgressBar.module.scss";

export interface FieldWrapperProps {
    className?: string;
    step?: number | string;
    maxSteps?: number | string;
    withSteps?: boolean;
}

export interface BaseFieldProps<T extends HTMLProgressElement> extends FieldWrapperProps, Partial<React.HTMLProps<T>> {}

/**
 * Generates a progress bar with optional progress text.
 */
export function ProgressBar(props: BaseFieldProps<HTMLProgressElement>): React.ReactElement {
    const {
        className,
        step = 0,
        maxSteps = 4,
        withSteps = true
    } = props;

    return (
        <div className={cn(styles.field, className)}>
            <progress className={styles.bar} max={maxSteps} value={step}></progress>
            {withSteps ? <span className={styles.steps}>{step}/{maxSteps}</span> : null}
        </div>
    );
}
